















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import IFormField from '@/modules/form/interfaces/IFormField.d.ts';

@Component({
    name: 'YesNoRadio',
    components: {},
})
export default class YesNoRadio extends Vue {
    @Prop() public formField!: IFormField;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private selectedValue: any = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private options: any[] = [
        { text: 'Yes / Tak', value: 'True' },
        { text: 'No / Nie', value: 'False' },
    ];

    @Watch('selectedValue', { immediate: true, deep: true })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private onCheckedOptionsChanged(val: any) {
        if (val === undefined || val === null) {
            console.log('selectedValue is undefined.');
        } else {
            this.formField.Value = val === 'True' ? 'true' : 'false';
        }
    }
}
